<template>
  <v-container fluid>
    <v-card class="mb-4">
      <v-card-title>Billing Removals (Audit)</v-card-title>
      <v-card-subtitle>Soft-deleted billings with snapshot + reason</v-card-subtitle>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="3">
            <v-text-field v-model="filters.removed_from" label="From (YYYY-MM-DD)" type="date" dense outlined hide-details />
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field v-model="filters.removed_to" label="To (YYYY-MM-DD)" type="date" dense outlined hide-details />
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field v-model.number="filters.customer_id" label="Customer ID" type="number" dense outlined hide-details />
          </v-col>
          <v-col cols="12" sm="2">
            <v-select v-model="filters.removed_via" :items="viaOptions" label="Removed Via" dense outlined hide-details clearable />
          </v-col>
          <v-col cols="12" sm="2" class="d-flex align-center">
            <v-btn color="primary" :loading="loading" @click="fetch">Apply</v-btn>
            <v-btn class="ml-2" color="success" :loading="exporting" @click="exportExcel">Export</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row class="mb-4" dense>
      <v-col cols="12" sm="4">
        <v-card outlined>
          <v-card-text>
            <div class="text-overline">Total Removals</div>
            <div class="text-h5">{{ summary.total_removals || 0 }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card outlined>
          <v-card-text>
            <div class="text-overline">Total Amount (LAK)</div>
            <div class="text-h5">{{ formatNumber(summary.total_amount_lak || 0) }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card outlined>
          <v-card-text>
            <div class="text-overline">By Removal Source</div>
            <div v-for="row in (summary.by_via || [])" :key="row.removed_via" class="text-body-2">
              {{ row.removed_via }}: {{ row.count }} ({{ formatNumber(row.total_lak) }} LAK)
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :items-per-page="100"
        :footer-props="{ 'items-per-page-options': [50, 100, 200] }"
        dense
      >
        <template #item.original_total="{ item }">{{ formatNumber(item.original_total) }}</template>
        <template #item.removed_at="{ item }">{{ item.removed_at }}</template>
        <template #item.customer="{ item }">
          {{ item.customer ? (item.customer.company_name || ((item.customer.name || '') + ' ' + (item.customer.surname || ''))).trim() : '' }}
          <span class="grey--text">#{{ item.customer_id }}</span>
        </template>
        <template #item.remover="{ item }">{{ item.remover ? item.remover.name : 'System' }}</template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import numberFormat from '../../Helpers/formatNumber';

export default {
  name: 'ReportBillingRemovals',
  title() {
    return `Vientiane Waste Co-Dev|Billing Removals`;
  },
  data() {
    return {
      filters: {
        removed_from: null,
        removed_to: null,
        customer_id: null,
        removed_via: null,
      },
      viaOptions: [
        { text: 'Observer (UI/Eloquent)', value: 'observer' },
        { text: 'Manual SQL', value: 'manual_sql' },
      ],
      summary: {},
      items: [],
      loading: false,
      exporting: false,
      headers: [
        { text: 'Removed At', value: 'removed_at' },
        { text: 'Billing ID', value: 'billing_id' },
        { text: 'Customer', value: 'customer' },
        { text: 'Bill Month', value: 'original_date_in_bill' },
        { text: 'Original Amount', value: 'original_total', align: 'right' },
        { text: 'Status', value: 'original_status' },
        { text: 'Via', value: 'removed_via' },
        { text: 'Reason', value: 'reason' },
        { text: 'Removed By', value: 'remover' },
      ],
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    formatNumber(n) {
      return numberFormat(n || 0);
    },
    buildParams() {
      return Object.fromEntries(
        Object.entries(this.filters).filter(([, v]) => v !== null && v !== ''),
      );
    },
    async fetch() {
      this.loading = true;
      try {
        const { data } = await this.$axios.get('v2/report-billing-removals', {
          params: this.buildParams(),
        });
        this.summary = data.summary || {};
        this.items = (data.items && data.items.data) || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async exportExcel() {
      this.exporting = true;
      try {
        const response = await this.$axios.get('v2/report-billing-removals/export', {
          params: this.buildParams(),
          responseType: 'blob',
        });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `billing-removals-${new Date().toISOString().slice(0, 10)}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
